export enum VerificationType {
    ROUTINE = 'ROUTINE',
    TRAVEL = 'TRAVEL',
    HOURS_UTILIZATION = 'HOURS_UTILIZATION',
}